import { MessageBox } from 'element-ui';

export default async ({
  message = '确认要进行此操作吗？',
  title = '提示',
  options,
}) => {
  let isCancel = false;
  await MessageBox.confirm(message, title, options).catch(() => {
    isCancel = true;
  });
  return isCancel;
};
